var PhxCheckout = (function (PhxCheckout) {

    /**
     * TODO: refer this from a global constant file.
     */
    PhxCheckout.cardTypes = {
        VISA: 'VI',
        MASTERCARD: 'MC',
        DISCOVER: 'DI',
        AMERICANEXPRESS: 'AX'
    };

    PhxCheckout.acceptedCreditCards = ["Visa", "MasterCard", "American Express", "Discover"];

    PhxCheckout.elementIds = {
        CREDIT_CARD_NUMBER: 'id_number',
        CREDIT_CARD_EXPIRATION_MONTH: 'id_expirationMonth',
        CREDIT_CARD_EXPIRATION_YEAR: 'id_expirationYear',
        CREDIT_CARD_SECURITY_CODE: 'id_securityCode',
        IBAN: 'id_iban',
        ACCOUNT_HOLDER: 'id_accountHolder',
        POSTAL_CODE: 'id_postalCode'
    };

    PhxCheckout.requestType = {
        VALID_REQUEST: 'VALID_REQUEST',
        INVALID_REQUEST: 'INVALID_REQUEST',
        DUPLICATE_REQUEST: 'DUPLICATE_REQUEST'
    };

    /*
     * flag used to determine if payment aut is in progress
     */
    PhxCheckout.paymentAuthInProgress = false;

    var defaultPosSubmitTimeout = 10000;  //10 sec default timeout unless optTimeout argument is supplied.
    var posResponseTextMsgLenMax = 200;   //New Relic has issues logging long messages.

    var cvvInputTimeout;                  //Holds timer id for cvv input.
    var cvvTypingValidationDelay = 1000;  //1 second delay between when user types inside cvv field and when we are running validation routines.


    /**
     * Checkout helper object
     */
    PhxCheckout.checkoutHelper = function () {

        var payload = {};
        var paymentType = '';
        var zipUntouched = true;


        //TODO: Create new input with inputType and replace existing input
        function _togglePostalCode(show, inputType) {
          var postalCodeDiv = document.getElementById('postalCode');
          var display = show ? 'inline-block' : 'none';
          postalCodeDiv.style.display = display;
        }

        function _setPaymentType(value) {
            paymentType = value;
            if (paymentType === 'CreditCard') {
                document.getElementById('dd_id').style.display = "none";
                document.getElementById('cc_id').style.display = "block";
            } else if (paymentType === 'DirectDebit') {
                document.getElementById('dd_id').style.display = "block";
                document.getElementById('cc_id').style.display = "none";
            }
        }

        function _getMaskedAccountNumber() {
            // example of result: 378282246310005 -> ***********0005
            var creditCardNumber = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
            var output = '';
            if (creditCardNumber) {
                creditCardNumber = creditCardNumber.value.replace(/ /g,'');

                //replace all numbers to asterisks except last 4
                var inputLength = creditCardNumber.length - 4;

                for(var l = 1; l <= inputLength; l++) {
                    output += '*';
                }
                //extract last four characters from the end
                output += creditCardNumber.substr(-4);
            }
            return output
        }

        function _getMaskedIBAN() {
            var ibanNumber = document.getElementById(PhxCheckout.elementIds.IBAN);
            return ibanNumber ? ibanNumber.value.replace(/ /g,'').substr(-4) : '';
        }

        function _getCardType() {
            var creditCardNumberElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
            crediCardFirstNumber = creditCardNumberElement ? creditCardNumberElement.value[0] : '';
            switch (crediCardFirstNumber) {
                case '4':
                    return PhxCheckout.cardTypes.VISA;
                case '2':
                case '5':
                    return PhxCheckout.cardTypes.MASTERCARD;
                case '6':
                    return PhxCheckout.cardTypes.DISCOVER;
                case '3':
                    return PhxCheckout.cardTypes.AMERICANEXPRESS;
                default:
                    return '';
            }
        }

        function _getExpirationMonth() {
            var expirationMonthElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_MONTH),
                expirationMonth;
            // Differntiates between dropdown and textbox based on the flow
            if (expirationMonthElement && expirationMonthElement.nodeType === 'SELECT') {
                expirationMonth = expirationMonthElement.options[expirationMonthElement.selectedIndex].text;
            } else if (expirationMonthElement) {
                expirationMonth = expirationMonthElement.value;
            }
            return expirationMonth;
        }

        function _getExpirationYear() {
            var expirationYearElement = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_YEAR),
                expirationYear;
            if (expirationYearElement && expirationYearElement.nodeType === 'SELECT') {
                expirationYear = expirationYearElement.options[expirationYearElement.selectedIndex].text;
            } else if (expirationYearElement) {
                expirationYear = expirationYearElement.value;
            }

            if(expirationYear.length === 2 ) {
              expirationYear = '20' + expirationYear;
            }

            return expirationYear;
        }

        /**
         * _getCreditCardInfo
         *
         * returns all the required credit card information.
         */
        function _getCreditCardInfo() {
            return {
                maskedCardNumber: _getMaskedAccountNumber(),
                expirationMonth: _getExpirationMonth(),
                expirationYear: _getExpirationYear(),
                cardType: _getCardType()
            };
        }

        /**
         * _getDirectDebitInfo
         *
         * returns all the required direct debit information.
         */
        function _getDirectDebitInfo() {
            return {
                maskedIBAN: '****' + _getMaskedIBAN()
            };
        }

        function _getPostalCode() {
          var postalElement = document.getElementById('id_postalCode');
          return postalElement.value;
        }

        /**
         * _sendCardTypeToParent
         *
         * Sends card type to the parent
         */
        function _sendCardTypeToParent() {
            var cardType = _getCardType(),
                payload = {
                    action: 'CARDTYPEEVENT',
                    data: cardType
                };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPaymentIdToParent() {
            var data = {};
            var query = window.location.search.substring(window.location.search.indexOf('&') + 1);
            var queryparams = query.split("&");
            for (var i = 0; i < queryparams.length; i++) {
                var pair = queryparams[i].split("=");
                data[pair[0]] = pair[1];
            }
            var payload = {
                action: 'PAYMENTIDEVENT',
                data: data
            };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _ping() {
            var payload = {action: 'PING'};
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPaymentTypeToParent() {
          payload = {
              action: 'PAYMENTTYPEEVENT',
              data: 'PayPal'
          };
          PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _appendDataToForm(form, data) {
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    var ff = document.createElement("input");
                    ff.name = key;
                    ff.id = key;
                    ff.type = "hidden";
                    ff.value = data[key];
                    form.appendChild(ff);
                }
            }
        }


        /* SDE POS data handling begins.
           _ajaxPostRequest(): Helper function.
        */
        function _ajaxPostRequest(url, data, resultHandler, optTimeout) {
            var params = typeof data == 'string' ? data : Object.keys(data).map(
                    function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
                ).join('&');

            var localWindow = PhxCheckout.util.getWindow();
            var xhr = localWindow.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
            var requestStartTime = new Date().getTime();      //Calculates response time.

            var resultHandlerCalled = false;                  //Optimization: flag to indicate if result handler has already been called
                                                              //(onerror() case for handling network-level failures).

            xhr.open('POST', url);
            xhr.timeout = optTimeout;
            xhr.onreadystatechange = function() {
                try {
                    if (xhr.readyState === 4) {             //Pass all completed responses - 200, 400, 418 and 500 status codes.
                        resultHandler(_createTokenResponse(xhr.status === 200, (xhr.status === 200) ? 'success' : 'error',
                                                           xhr.status, xhr.responseText, requestStartTime));
                        resultHandlerCalled = true;
                    }
                } catch (e) {   //Handle additional cases (https://developer.mozilla.org/en-US/docs/AJAX/Getting_Started)
                    resultHandler(_createTokenResponse(false, 'xhr failed', 0, JSON.stringify(e), requestStartTime));
                    resultHandlerCalled = true;
                }
            };

            //Log timeout.
            xhr.ontimeout = function() {
                resultHandler(_createTokenResponse(false, 'timeout', xhr.status, xhr.responseText, requestStartTime));
            };

            //Catch additional errors that are at the network level (only if not already caught via onreadystatechange()).
            xhr.onerror = function(e) {
                if (! resultHandlerCalled)
                    resultHandler(_createTokenResponse(false, 'error', xhr.status, xhr.responseText, requestStartTime));
            };

            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.send(params);

            return xhr;
        }

        /* createTokenResponse(): returns a message object ready for logging and sending back to the parent window.
           Note:
           responseText is reduced to posResponseTextMsgLenMax size as excess size causes none of the text to appear in NR logs.
        */
        function _createTokenResponse(success, opResultText, responseStatus, responseText, requestStartTime) {
            return {
                success: success,
                responseText: (responseText !== null && responseText.length > 0) ? responseText.substr(0, posResponseTextMsgLenMax) : '',
                responseStatus: responseStatus,
                opResultText: opResultText,
                opResponseTime: new Date().getTime() - requestStartTime
            };
        }

        // Posts data to SDE POS and emits message back
        // to parent frame to continue the pmt flow.
        function _submitSdeData(data) {
            //
            // avoids duplicate authorization calls when double clicks are not propely
            // handled at the calling application.
            //
            if (PhxCheckout.paymentAuthInProgress) {
                return _getSdeSyncResponse(PhxCheckout.requestType.DUPLICATE_REQUEST);
            }

            // Adds optional timeout as a parameter.
            var optTimeout = (typeof data.optTimeout === 'undefined') ? defaultPosSubmitTimeout : data.optTimeout;

            var payload = data.payload;
            var endpoint = data.endpoint;

            if (paymentType === 'CreditCard') {
                var creditCardNumber = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER);
                var cardNum = creditCardNumber.value.replace(/[^\d]+/g,'');

                var creditCardSecurityCode = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE);
                var cvv = creditCardSecurityCode.value.replace(/[^\d]+/g,'');

                payload.card.cardNumber = cardNum;
                payload.card.expirationYear = _getExpirationYear();
                payload.card.expirationMonth = _getExpirationMonth();
                payload.card.cvv = cvv;
            } else if (paymentType === 'DirectDebit') {
                var iban = document.getElementById(PhxCheckout.elementIds.IBAN).value.replace(/\s/g, '');
                payload.iban = iban;
            }

            //Additional log data to help us identify response failures to request data.
            var correlationLogData = {
              userId: typeof payload.userId === 'undefined' ? '' : payload.userId,
              locale: typeof payload.locale === 'undefined' ? '' : payload.locale
            };

            //Adds logging for the SDE request.
            PhxCheckout.logger.logEventToServer('iFramePostPosData', {
              'posType': 'SDE', 'posAction': 'preAjaxRequest', 'posResult': '',
              'posResultCode': '', 'posResultMsg': '',
              'posUserId': correlationLogData.userId, 'posLocale': correlationLogData.locale
            });

            // set to avoid duplicate authorizations
            PhxCheckout.paymentAuthInProgress = true;
            try {
                _ajaxPostRequest(    //After SDE completes (async update).
                endpoint,
                JSON.stringify(payload),
                function(response) {

                    // resets duplicate authorization flag afer SDE response
                    PhxCheckout.paymentAuthInProgress = false;

                    //Add additional data to the response back to the parent window for error handling.
                    var sdeData = {
                        action: 'PAYMENTIDEVENT',
                        success: response.success,
                        responseText: response.responseText,
                        responseStatus: response.responseStatus,
                        opResultText: response.opResultText,
                        opResponseTime: response.opResponseTime,
                        data: {}
                    };

                    //Case 1: Successful ajax call but no wallet ID.
                    //Case 2: Failed ajax call (below).
                    if (response.success) {
                        try {
                            jResponse = JSON.parse(response.responseText);
                            sdeData.data.payment_id = jResponse.walletId;
                            sdeData.data.payment_site_id = jResponse.paymentSiteId;
                            if (jResponse.bin) {
                                sdeData.data.bin = jResponse.bin;
                            }
                        } catch (e) {
                            if (PhxCheckout.logger.hasConsole()) {
                                console.log('Response from SDE was successful but could not be parsed. ' + JSON.stringify(e));
                            }
                        }
                    }

                    //Log to New Relic.
                    PhxCheckout.logger.logEventToServer('iFramePostPosData', {
                        posType: 'SDE',
                        posAction: 'ajaxRequest',
                        posResult: response.opResultText,
                        posResultCode: response.responseStatus,
                        posResultMsg: response.responseText,
                        posUserId: correlationLogData.userId,
                        posLocale: correlationLogData.locale,
                        posResponseTime: response.opResponseTime
                    });


                    PhxCheckout.messenger.postMessageToParent(sdeData);
                },
                optTimeout
                );
            }
            catch (e)  {
                // resets duplicate authorization flag for any uncaught errors
                PhxCheckout.paymentAuthInProgress = false;
            }
            //Sync return to match form post return.
            return _getSdeSyncResponse(PhxCheckout.requestType.VALID_REQUEST);
        }


        function _getSdeSyncResponse(requestType) {
            requestType = requestType || PhxCheckout.requestType.VALID_REQUEST;
            var sdeSyncResponse;
            if (paymentType === 'CreditCard') {
                sdeSyncResponse = _getCreditCardInfo();
            } else if (paymentType === 'DirectDebit') {
                sdeSyncResponse = _getDirectDebitInfo();
            }

            sdeSyncResponse.requestType = requestType;
            return sdeSyncResponse;
        }
        /* SDE data handling ends. */


        function _submitForm(data) {
            //Adds logging for the classical POS submitform event.
            PhxCheckout.logger.logEventToServer('iFramePostPosData', {
                posType: 'Classical POS',
                posAction: 'submitForm',
                posResult: '',
                posResultCode: '',
                posResultMsg: '',
                posUserId: typeof data.ucdmid === 'undefined' ? '' : data.ucdmid,
                posLocale: typeof data.locale === 'undefined' ? '' : data.locale,
                offerUrl: typeof data.ApplicationUrl === 'undefined' ? '' : data.ApplicationUrl
            });

            var posTokenForm = document.getElementById('posTokenForm');
            _appendDataToForm(posTokenForm, data);
            posTokenForm.submit();
            return _getCreditCardInfo();
        }


        function _autoSpace (obj, event) {
            var cardNum = obj.value;

            if ( !cardNum || cardNum.length === 0) {
                return;
            }

            var leftSide = cardNum.slice(0, obj.selectionStart);
            var matches = leftSide.match(new RegExp(' ', 'gi'));
            var numLeftSpaces = matches ? matches.length : 0;
            var numLeftDigits = obj.selectionStart - numLeftSpaces;
            var numRightDigits = cardNum.length - numLeftDigits;
            var cardType = _getCardType();

            cardNum = cardNum.replace(/[^\d]+/g,'');
            var length = cardNum.length;

            var maxLength = 22;
            switch (cardType) {
                case PhxCheckout.cardTypes.VISA:
                    maxLength = 27;
                    break;
                case PhxCheckout.cardTypes.AMERICANEXPRESS:
                    maxLength = 19;
                    break;
            }

            if(cardNum === '') {
                obj.value = cardNum;
                return;
            } else if (cardType === PhxCheckout.cardTypes.AMERICANEXPRESS) {
                var P1 = cardNum.substr(0, 4);
                var P2 = cardNum.substr(4, 6);
                var P3 = cardNum.substr(10);
                cardNum = [P1, P2, P3].join("  ").replace(/ +$/,'');
                cardNum = cardNum.substr(0, maxLength);
            } else {
                cardNum = cardNum.match(new RegExp('.{1,4}', 'g')).join("  ");
                cardNum = cardNum.substr(0, maxLength);
            }

            var prevChar = obj.value[obj.selectionStart - 1];
            var currChar = obj.value[obj.selectionStart];
            var nextChar = obj.value[obj.selectionStart + 1];
            //check string discarding white space at end
            if ( obj.value.replace(/ +$/,'') != cardNum) {
                obj.value = cardNum.substr(0, maxLength);


                var count = 0;
                for(var i = 0; i < cardNum.length; i++) {
                    var char = cardNum[i];
                    if (char != ' ') {
                        if (count === numLeftDigits) {
                            //special case with deleting spaces
                            if( (prevChar === ' ' || currChar === ' ' ) && nextChar != ' ' && event.code === 'Backspace') {
                                obj.setSelectionRange(i-2, i-2);
                            } else {
                                obj.setSelectionRange(i, i);
                            }
                            return;
                        }
                        count += 1;
                    }
                }
            }
        }

        function _autoTab(obj, event, tabToElement, maxLength) {
            //special case for shift tab events to not autofocus
            if ( (event.code === 'Tab') || (event.code === 'ShiftLeft') || (event.code === 'ShiftRight')) {
                return;
            }
            if (obj.value.length >= maxLength) {
                document.getElementById(tabToElement).focus();
            }
        }

        function _displayCVCodeTooltip(obj) {
            if(obj.value.length) {
                var cardFirstNum = obj.value[0];
                var tooltip = document.getElementById('securityCodeTooltipContent');
                if (tooltip) {
                    tooltip.style.display = (cardFirstNum === '3') ? 'none' : '';
                    document.getElementById('securityCodeTooltipContentForAmExp').style.display = (cardFirstNum === '3') ? '' : 'none';
                }
                document.getElementById('contentCVCode').className = '';
            } else {
                document.getElementById('contentCVCode').className = 'noDisplay';
            }
        }

        function _toggleCalloutExternal(value) {
            var calloutBtnDimensions = document.getElementById('securityCodeHelpTrigger').getBoundingClientRect();
            var _calloutBtnDimensions = {};
            // firefox can't pass an object with methods via postMessage
            for (property in calloutBtnDimensions){
              _calloutBtnDimensions[property] = calloutBtnDimensions[property];
            }

            //delete toJSON function because functions can't be passed through postMessages
            delete _calloutBtnDimensions.toJSON;
            payload = {
                action: 'TOGGLECALLOUTEVENT',
                data: {'state': value,
                       'calloutBtnDimensions': _calloutBtnDimensions,
                       'validationMessageHeight': document.getElementById('ccValidationSuccess').clientHeight}
            };
            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _toggleCallout(state) {
            if(state === 1) {
                _setCallbackProperties();
            }

            var display = (state === 1) ? 'inline' : 'none';
            var wrapIframe = document.getElementById('calloutWrapIframe');

            wrapIframe.style.display = display;
        }

        function _getWindowWidth() {
          var localWindow = PhxCheckout.util.getWindow();
          return localWindow.innerWidth;
        }

        function _setCallbackProperties() {
            var outerCallout = document.getElementById('calloutWrapIframe');
            var calloutBtnDimensions = document.getElementById('securityCodeHelpTrigger').getBoundingClientRect();
            var ccErrors = document.getElementById('cc_errors_wrapper').style.display === 'inline-block' ? 1 : 0;

            var windowWidth = _getWindowWidth();
            if(windowWidth < 547) {
                outerCallout.className = 'callout calloutPositionLeft fadeIn';
                outerCallout.style.left = calloutBtnDimensions.left - 240;
            } else {
                outerCallout.className = 'callout calloutPositionRight fadeIn';
                outerCallout.style.left = calloutBtnDimensions.left + 22;
            }

            if(windowWidth < 380) {
                outerCallout.style.top = ccErrors ? '47px' : '15px';
            } else {
                outerCallout.style.top = ccErrors ? '30px' : '10px';
            }
        }

        function _forceNumeric(obj){
            obj.value = obj.value.replace(/[^\d]+/g,'') ;
        }

        //only used to reset values for testing
        function _resetCcTransitionState() {
          _ccTransitionState = ''
        }


        /* _setCVVMaxLength(): sets maximum accepted length for CVV field depending on CC type.
           Also: if cvv field contains digits, run cvv validation to ensure that the length is
           still valid for that particular card.
        */
        function _setCVVMaxLength() {
            var cvvField = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE);
            var maxLengthForCVV = PhxCheckout.creditCardValidationHelper.getCVVLengthForCreditCard();
            cvvField.setAttribute('maxLength', maxLengthForCVV);

            //Trim CVV length to fit the card spec.
            if (cvvField.value.length > maxLengthForCVV) {
                cvvField.value = cvvField.value.substring(0, maxLengthForCVV);
            }

            /* If there is a CVV already entered, validate it as the CC # could be changing.
               Even though the call is bit expensive for every stroke, we are using delayed version to
               throttle calls to validator while the user is typing.  Also the validation is almost instantenous
               and does not require user to tab out to see whether their CVV is valid or not after CC #.
            */
            if (cvvField.value.length > 0) {
                _validateSecurityCodeOnKeypress();
            }
        }


        //_validateSecurityCodeOnKeypress(): delayed validation until user stops typing for X milliseconds.
        function _validateSecurityCodeOnKeypress() {
            clearTimeout(cvvInputTimeout);

            cvvInputTimeout = setTimeout(function() {
                PhxCheckout.creditCardValidationHelper.validateSecurityCode();
            }, cvvTypingValidationDelay);
        }


        function _autoFill() {
            document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_NUMBER).value = '378282246310005';
            document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_MONTH).value = '03';
            document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_SECURITY_CODE).value = '2232';
            var postal = document.getElementById(PhxCheckout.elementIds.POSTAL_CODE);
            if (postal) {
              postal.value = '94107';
            }

            var year = '2022';
            var yearElem = document.getElementById(PhxCheckout.elementIds.CREDIT_CARD_EXPIRATION_YEAR);
            if (yearElem.getAttribute('maxlength') === '2') {
                year = '22'
            }
            yearElem.value = year;
        }

        function _updateFrameSize () {
            var ccErrorsState = document.getElementById('cc_errors_wrapper').style.display === 'inline-block' ? 1 : 0;
            var cvcErrorState = document.getElementById('cvc_error').style.display === 'inline-block' ? 1 : 0;
            var expErrorState = document.getElementById('expiration_error').style.display === 'inline-block' ? 1 : 0;
            var postalErrorState = document.getElementById('postal_error') && document.getElementById('postal_error').style.display === 'inline-block' ? 1 : 0;
            var postalInputDisplayed = document.getElementById('postalCode') && document.getElementById('postalCode').style.display !== 'none';

            var useThreeLines =  (_getWindowWidth() <= 490) && postalInputDisplayed;

            //height variables for calculations
            var ccErrHeight = 38;
            var defaultErrHeight = 20;
            var postalHeight = 50;
            var calcHeight = 150;

            //cc error can have wrapped text so it needs to be larger
            if (ccErrorsState) calcHeight += ccErrHeight;
            if (useThreeLines) {
              //add the height of line 3
              calcHeight += postalHeight;
              //line two has cvc and exp inputs
              if (cvcErrorState || expErrorState ) {
                calcHeight += defaultErrHeight;
              }
              //line three just postal input
              if(postalErrorState) calcHeight += defaultErrHeight;
            } else {
              //line two has cvc, exp, and inputs
              if (cvcErrorState || expErrorState || postalErrorState) {
                calcHeight += defaultErrHeight;
              }
            }

            var frameHeight = calcHeight + 'px';

            var payload = {
                action: 'UPDATEFRAMESIZEEVENT',
                data: {'height': frameHeight}
            };

            PhxCheckout.messenger.postMessageToParent(payload);
        }

        function _sendPostalCode(shipingZip) {
          if (!zipUntouched) return;
          document.getElementById('id_postalCode').value = shipingZip;
        }

        function _onPostalBlur() {
          zipUntouched = false;
        }


        return {
            autoSpace: _autoSpace,
            autoTab: _autoTab,
            displayCVCodeTooltip: _displayCVCodeTooltip,
            getCreditCardInfo: _getCreditCardInfo,
            getCardType: _getCardType,                  /* Information already returned as part of getCreditCardInfo. */
            setPaymentType: _setPaymentType,
            sendCardTypeToParent: _sendCardTypeToParent,
            sendPaymentTypeToParent: _sendPaymentTypeToParent,
            sendPaymentIdToParent: _sendPaymentIdToParent,
            setCVVMaxLength: _setCVVMaxLength,
            submitForm: _submitForm,
            createTokenResponse: _createTokenResponse,
            submitSdeData: _submitSdeData,
            toggleCallout: _toggleCallout,
            toggleCalloutExternal: _toggleCalloutExternal,
            forceNumeric: _forceNumeric,
            validateSecurityCodeOnKeypress: _validateSecurityCodeOnKeypress,
            autoFill: _autoFill,
            ping: _ping,
            getPostalCode: _getPostalCode,
            togglePostalCode: _togglePostalCode,
            onPostalBlur: _onPostalBlur,
            sendPostalCode: _sendPostalCode,
            //testing only
            _resetCcTransitionState: _resetCcTransitionState,
            updateFrameSize: _updateFrameSize
        };
    }();

    return PhxCheckout;

}(PhxCheckout || {}));
